import React, { useEffect, useState } from "react";
import { notification } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import { UploadDragger, StapletIcon, CountFiles } from "./Uploader.styled";

interface Props {
  value?: UploadFile[];
  onChange?: (val) => void;
}

export default function Uploader({
  value = [],
  onChange,
  ...restProps
}: Props) {
  const [errorSizeAll, setErrorSizeAll] = useState(false);

  useEffect(() => {
    if (value.length > 10) {
      notification.error({
        placement: "bottomRight",
        message: "Количество загружаемых файлов не может превышать 10",
      });
      onChange(value.slice(0, 10));
    }

    const sizeAll = value.reduce((acc: number, item) => acc + item.size, 0);

    if (sizeAll > 10 * 1024 * 1024) {
      setErrorSizeAll(true);

      // notification.error({
      //   placement: "bottomRight",
      //   message: "Размер допольнительных загружаемых файлов больше 10мб",
      // });
    } else {
      setErrorSizeAll(false);
    }
  }, [value, onChange]);

  return (
    <>
      <UploadDragger
        style={errorSizeAll ? { border: "1px solid red" } : {}}
        multiple={true}
        beforeUpload={() => false}
        fileList={value}
        accept=".jpg, .jpeg, .png, .tiff, .pdf, .docx, .xlsx"
        onChange={({ file, fileList }) => {
          const validate = (size) => size > 0 && size < 10 * 1024 * 1024;
          const regex = /[*|":<>[\]{}`\\'&%~#]/.test(file.name);
          const doubleDot = !file.name.match(/\.\./);
          const dot = !file.name.match(/^[.]/);

          if (file.size === 0) {
            notification.error({
              placement: "bottomRight",
              message: "Файл не может быть пустым",
            });
          } else if (!validate(file.size)) {
            notification.error({
              placement: "bottomRight",
              message: `Размер файла ${file.name} больше 10мб`,
            });
          } else if (regex || doubleDot === false || dot === false) {
            notification.error({
              placement: "bottomRight",
              message: `Имя загружаемого файла ${file.name} содержит недопустимые знаки. Измените имя файла.
            К недопустимым относятся следующие знаки: ~ " # % & * : < > ? / \\ { | }. Имя не может начинаться или завершаться точкой,
            а также не может содержать несколько точек подряд.`,
              duration: null,
            });
          } else {
            onChange(
              fileList.filter((f) => {
                if (
                  validate(f.size) &&
                  !/[*|":<>[\]{}`\\'&%~#]/.test(f.name) &&
                  !/\.\./.test(f.name) &&
                  !/^[.]/.test(f.name)
                ) {
                  return f;
                } else {
                  return null;
                }
              })
            );
          }
        }}
        {...restProps}
      >
        <StapletIcon />{" "}
        {errorSizeAll
          ? "Добавьте дополнительные файлы не более 10 Мб"
          : "Добавить дополнительные файлы не более 10 Мб"}
      </UploadDragger>
      {value.length < 1 ? null : (
        <CountFiles>
          Количество дополнительно загруженных файлов {value.length}/10
        </CountFiles>
      )}
    </>
  );
}
